import Http from "./base-http";

class StoreBudget extends Http {
  addStoreBudget(variables) {
    return this.create(variables);
  }
  deleteStoreBud(id) {
    return this.destroy(id);
  }
}
const storeBudget = new StoreBudget({
  modelUrlPrefix : "StoreBudget"
});
export default storeBudget;